import { Link } from "react-router-dom";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faGithub, faInstagram, faLinkedin, faXTwitter } from "@fortawesome/free-brands-svg-icons";


export function LeetCodeIcon(props) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M13.483 0a1.374 1.374 0 0 0-.961.438L7.116 6.226l-3.854 4.126a5.266 5.266 0 0 0-1.209 2.104a5.35 5.35 0 0 0-.125.513a5.527 5.527 0 0 0 .062 2.362a5.83 5.83 0 0 0 .349 1.017a5.938 5.938 0 0 0 1.271 1.818l4.277 4.193l.039.038c2.248 2.165 5.852 2.133 8.063-.074l2.396-2.392c.54-.54.54-1.414.003-1.955a1.378 1.378 0 0 0-1.951-.003l-2.396 2.392a3.021 3.021 0 0 1-4.205.038l-.02-.019l-4.276-4.193c-.652-.64-.972-1.469-.948-2.263a2.68 2.68 0 0 1 .066-.523a2.545 2.545 0 0 1 .619-1.164L9.13 8.114c1.058-1.134 3.204-1.27 4.43-.278l3.501 2.831c.593.48 1.461.387 1.94-.207a1.384 1.384 0 0 0-.207-1.943l-3.5-2.831c-.8-.647-1.766-1.045-2.774-1.202l2.015-2.158A1.384 1.384 0 0 0 13.483 0m-2.866 12.815a1.38 1.38 0 0 0-1.38 1.382a1.38 1.38 0 0 0 1.38 1.382H20.79a1.38 1.38 0 0 0 1.38-1.382a1.38 1.38 0 0 0-1.38-1.382z"></path></svg>);
}
const Footer = (props) => {

    var topWorks = props.topWorks;
    if (topWorks == null) {
        topWorks = { 0: { name: "EduMetrics Pro", link: "project/EduMetrics Pro" }, 1: { name: "Space Shooter", link: "project/Space%20Shooter" }, };
    }
    // console.log(Object.entries(topWorks));

    return (
        <footer>
            <div className="top">
                <div className="left short-content">
                    <h1>Naveen N</h1>
                    <p>Having learned a bit about me, I hope you'll consider connecting further and acknowledging my work.</p>
                </div>
                <div className="right links">
                    <div className="follow-up">
                        <h2>Follow Up</h2>
                        <ul>
                            <li><a href="https://www.linkedin.com/in/naveenn82005/" target="_blank" rel="noreferrer">Linked In<FontAwesomeIcon className="fontawesome-icon" icon={faLinkedin} /></a></li>
                            <li><a href="https://github.com/Navin82005/" target="_blank" rel="noreferrer">GitHub<FontAwesomeIcon className="fontawesome-icon" icon={faGithub} /></a></li>
                            <li><a href="https://leetcode.com/navin82005/" target="_blank" rel="noreferrer">LeetCode &nbsp;<LeetCodeIcon /></a></li>
                        </ul>
                    </div>
                    <div className="quick-links">
                        <h2>Quick Links</h2>
                        <ul>
                            <li><Link to={"/recruit"}>Recruit Me</Link></li>
                            <li><Link to={"/services/freelancing"}>FreeLancing</Link></li>
                            <li><Link to={"/contact"}>Contact me</Link></li>
                        </ul>
                    </div>
                    <div className="top-works">
                        <h2>Works</h2>
                        <ul>
                            {Object.entries(topWorks).map(([e, b]) => <li key={e}><Link to={`/${b.link}`}>{b.name}</Link></li>)}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="copy-right">
                <div><p>©&nbsp;2024 Naveen N, The Divine Visionary.</p></div>
                <div>
                    <ul>
                        <li><a href="https://www.instagram.com/_.nxvin._08/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a></li>
                        <li><a href="https://facebook.com/profile.php?id=100016635333597" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a></li>
                        <li><a href="https://twitter.com/NaveenN82005/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a></li>
                    </ul>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
